import { useMemo, useState } from 'react';
import { extractFields, fillPrompt } from '../../utils/prompt';

export function usePromptCard(text: string) {
  const fields = useMemo(() => extractFields(text), [text]);
  const [values, setValues] = useState<Record<string, string>>({});
  const [copied, setCopied] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [customizing, setCustomizing] = useState(false);

  const filledCount = fields.filter(f => values[f]?.trim()).length;
  const missing = fields.length - filledCount;
  const finalText = fillPrompt(text, values);

  const setValue = (field: string, value: string) => setValues(v => ({ ...v, [field]: value }));

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(finalText);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
      return true;
    } catch {
      return false;
    }
  };

  const openIn = async (url: string) => {
    await copy();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return {
    fields, values, setValue, filledCount, missing, finalText,
    copied, copy, openIn, expanded, setExpanded, customizing, setCustomizing,
  };
}
